import { Tooltip as NovaTooltip, TooltipProps as NovaTooltipProps } from '@fme-nova/components'
import { Tooltip as MuiTooltipBase, TooltipProps as MuiTooltipProps } from '@mui/material'
import React from 'react'

import { createComponentWrapperWithRef } from '../../theme'

const NovaBaseTooltip: React.FC<NovaTooltipProps> = (props) => {
  return <NovaTooltip placement={props.placement ?? 'top'} {...props} />
}

const BaseTooltip = createComponentWrapperWithRef<MuiTooltipProps | NovaTooltipProps>(
  {
    mui: MuiTooltipBase,
    nova: NovaBaseTooltip,
  },
  'BaseTooltip',
)

export const Tooltip: React.FC<MuiTooltipProps> = ({ title, slotProps: { tooltip, ...slotProps } = {}, ...props }) => {
  const { sx, ...tooltipProps } = tooltip ?? {}

  return (
    <BaseTooltip
      {...props}
      title={typeof title === 'string' ? title.replace(/[\t\r]/g, '').trimStart() : title}
      slotProps={{
        ...slotProps,
        tooltip: {
          ...tooltipProps,
          sx: { ...sx, whiteSpace: 'pre-wrap' },
        },
      }}
    />
  )
}
